/**
 * @file index.ts
 *
 * @fileoverview Exports blogs graphql utils.
 */

import { ConditionGroupInput } from '~/jobiqo/types/types';

/**
 * Constructs variables for the getBlogPosts.gql query.
 *
 * @param category
 *  The searched category.
 * @param search
 *  The searched term.
 * @param limit
 *  The limit of blogs to display.
 * @param page
 *  The current page.
 * @param locale
 *  Locale.
 * @returns
 *  Variables object to use within query.
 */
export function getBlogPostsVariables(
  search: string | string[],
  limit: number,
  page?: string | string[],
  locale?: string,
  category?: number,
  tag?: number,
  path?: string,
): {} {
  const groups: ConditionGroupInput[] = [];

  if (category) {
    groups.push({
      tags: ['facet:field_blog_category'],
      conditions: [
        {
          name: 'field_blog_category',
          value: category.toString(),
        },
      ],
    });
  }

  if (tag) {
    groups.push({
      tags: ['facet:field_blog_tags'],
      conditions: [
        {
          name: 'field_blog_tags',
          value: tag.toString(),
        },
      ],
    });
  }

  // If we are on the root blog search URL, exclude
  // featured blogs from the result.
  if (path === '/blog') {
    groups.push({
      conditions: [
        {
          value: '0',
          operator: '=',
          name: 'field_blog_featured',
        },
      ],
      conjunction: 'AND',
    });
  }

  return {
    category,
    language: locale,
    fulltext: {
      keys: search,
    },
    condition_group: {
      groups,
    },
    range: {
      first: page && Number(page) > 0 ? (Number(page) - 1) * limit : 0,
      last: limit,
    },
    searchPath: path,
  };
}
